import { useMutation } from "urql";

import { CreateLimitRequestConditionPrecedentDocument } from "../../../graphql/generated.ts";

export function useCreateLimitRequestConditionPrecedent() {
  return useMutation(CreateLimitRequestConditionPrecedentDocument);
}
